import { ASC } from './table/constants';

const alphanumericSort = (sort, prev, next) => {
  // Note: Number('') returns 0
  const truePrev = Number.isNaN(Number(prev)) || prev === '' ? prev.toUpperCase() : Number(prev);
  const trueNext = Number.isNaN(Number(next)) || next === '' ? next.toUpperCase() : Number(next);
  if (sort === ASC) {
    return truePrev > trueNext;
  }
  return truePrev < trueNext;
};

export default alphanumericSort;
